import { useOutletContext } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import AddSupervisorModalV1 from 'modules/surveys/components/Configuration/AddSupervisorModalV1'
import AddEditorModal from 'modules/surveys/components/Settings/Editors/AddEditorModal'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type SurveyForm from 'modules/surveys/store/models/Form'

export default function AddSupervisorPage() {
  const { form } = useOutletContext<{ form: SurveyForm }>()
  const { survey, hasSurveyV2 } = useSurveyShowContext()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return hasSurveyV2 && survey ? (
    <AddEditorModal survey={survey} contractVersions={contractVersions} loading={loading} />
  ) : (
    <AddSupervisorModalV1 form={form} contractVersions={contractVersions} loading={loading} />
  )
}
